import { trackEvent } from '../../lib/analytics';
import { useConsultaModal } from '../../context/ConsultaModalContext';

export const LandingAdvantage = () => {
    const { open } = useConsultaModal();
    return (
        <section className="py-32 bg-pacces-ebony text-white font-sans border-y border-pacces-gold/10">
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid lg:grid-cols-12 gap-16 items-center relative">
                    <div className="lg:col-span-7 space-y-12">
                        <div className="space-y-4">
                            <span className="text-pacces-gold font-bold text-[12px] uppercase tracking-[0.5em] block">Atendimento Exclusivo</span>
                            <h2 className="text-5xl md:text-6xl font-serif leading-[0.9] tracking-tighter">Consultoria <br />Jurídica</h2>
                        </div>

                        <div className="space-y-8">
                            <p className="text-xl text-stone-300 leading-relaxed font-light">
                                Uma análise jurídica e personalizada sobre o seu caso, a fim de traçar a melhor estratégia jurídica.
                            </p>
                            <ul className="space-y-6">
                                <li className="flex items-center gap-4">
                                    <span className="material-symbols-outlined text-pacces-gold text-2xl">verified</span>
                                    <span className="text-stone-200 font-bold text-sm tracking-tight uppercase">Análise Técnica Especializada</span>
                                </li>
                                <li className="flex items-center gap-4">
                                    <span className="material-symbols-outlined text-pacces-gold text-2xl">verified</span>
                                    <span className="text-stone-200 font-bold text-sm tracking-tight uppercase">Planejamento de Segurança Jurídica</span>
                                </li>
                                <li className="flex items-center gap-4">
                                    <span className="material-symbols-outlined text-pacces-gold text-2xl">verified</span>
                                    <span className="text-stone-200 font-bold text-sm tracking-tight uppercase">Foco em Resultados e Prevenção</span>
                                </li>
                            </ul>
                            <div className="pt-8">
                                <button
                                    onClick={() => { open(); trackEvent('consultoria_cta_click', { cta: 'agendar_consulta' }); }}
                                    className="inline-flex items-center justify-center bg-pacces-gold text-pacces-ebony px-12 py-5 font-bold uppercase text-[12px] tracking-[0.4em] hover:bg-white hover:text-pacces-ebony transition-all duration-300 rounded-sm shadow-xl"
                                >
                                    Agendar Minha Consulta
                                    <span className="material-symbols-outlined text-sm ml-2">east</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="lg:col-span-5 flex justify-center lg:justify-end">
                        <img
                            src="/luke-consultoria-juridica.jpeg"
                            className="w-full max-w-md h-auto max-h-[600px] object-contain grayscale hover:grayscale-0 transition-all duration-1000 drop-shadow-2xl"
                            alt="Dr. Luke de Tomaso Pacces - Advocacia Estratégica"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};
